import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const ModalWrapper = styled.div<{placement?:any}>`
    position: fixed;
    left:${props => props.placement?.left?props.placement.left:"0"};
    top:${props => props.placement?.top?props.placement.top:"0"};
    height:${props => props.placement?.height?props.placement.height:"100vh"};
    width:${props => props.placement?.width?props.placement.width:"100vw"};
    display:flex;
    align-items: center;;
    justify-content: center;
    
`;

export const ModalBackground = styled.div<{$backColor?:string}>`
    position: absolute;
    height:100%;
    width:100%;
    z-index: 2;
    background:${props => props.$backColor?props.$backColor:"transparent"};
    content: ' ';
    opacity:0;
    /* Promote to its own GPU layer up front - iOS Safari/WKWebView can do a visible
       repaint/flash the first time GSAP mutates opacity if the layer is only promoted mid-animation. */
    will-change: opacity;
    transform: translateZ(0);
`;

export const ModalContainer = styled.div<{fadeTop?:boolean, stickBottom?:boolean}>`
    z-index: 100;
    opacity:0;
    transform: ${props => props.fadeTop?"translateY(-30px)":"translateY(30px)"};
    width:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    will-change: opacity, transform;

    >div{
        pointer-events: all;
    }

    ${mq(Devices.tablet)}{
        margin-top: ${props => props.stickBottom?"auto":"unset"};
    }
`;


export const ModalContainerCus = styled.div<{fadeTop?:boolean, stickBottom?:boolean}>`
    z-index: 3;
    opacity:1;
    transform: scale(0);
    width:100%;
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    will-change: transform;

    >div{
        pointer-events: all;
    }
`;